import React from 'react';

/**
 * We need this to be able to forward generics to components with forwarded refs.
 *
 * @see https://www.totaltypescript.com/forwardref-with-generic-components
 */
export function fixedForwardRef<T, P = object>(
  render: (props: P, ref: React.Ref<T>) => React.ReactNode
): (props: P & React.RefAttributes<T>) => React.ReactNode {
  return React.forwardRef(render) as any;
}
